export const messages = {
    "wr-dashboard.search.input.hint": "Pencarian",
    "wr-dashboard.search.label.breadcrumb": "Hasil pencarian",
    "wr-dashboard.search.message.empty": "Tidak ada item yang cocok dengan pencarian Anda",
    "wr-dashboard.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "File",
    "wr-dashboard.side-bar.backup-type.notarized": "File dan folder yang dinotarisasikan",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplikasi - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplikasi - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplikasi - Keadaan sistem",
    "wr-dashboard.side-bar.backup-type.application": "Aplikasi",
    "wr-dashboard.backups-table.column.name": "Nama",
    "wr-dashboard.backups-table.column.size": "Ukuran",
    "wr-dashboard.backups-table.column.version": "Versi terakhir",
    "wr-dashboard.backups-table.action.delete": "Hapus",
    "wr-dashboard.backups-table.message.no-backups": "Belum ada cadangan dalam Awan",
    "wr-dashboard.backups-sidebar.label.size": "Ukuran",
    "wr-dashboard.backups-sidebar.label.type": "Jenis",
    "wr-dashboard.backups-sidebar.label.version": "Versi terakhir",
    "wr-dashboard.backups-sidebar.label.created": "Dibuat",
    "wr-dashboard.backups-sidebar.label.machine": "Mesin",
    "wr-dashboard.backups-sidebar.label.owner": "Pemilik",
    "wr-dashboard.content-table.column.name": "Nama",
    "wr-dashboard.content-table.column.versions": "Versi",
    "wr-dashboard.content-table.column.volumes": "Volume",
    "wr-dashboard.content-table.column.path": "Jalur",
    "wr-dashboard.content-table.column.size": "Ukuran",
    "wr-dashboard.content-table.column.version": "Versi terakhir",
    "wr-dashboard.content-table.action.notary-verify": "Verifikasi",
    "wr-dashboard.content-table.action.notary-get-crt": "Dapatkan sertifikat",
    "wr-dashboard.content-table.action.asign": "Dikirim untuk ditandatangani",
    "wr-dashboard.content-table.action.versions": "Versi",
    "wr-dashboard.content-table.action.restore": "Unduh",
    "wr-dashboard.content-table.label.size": "Ukuran",
    "wr-dashboard.content-table.label.created": "Dibuat",
    "wr-dashboard.content-table.label.modified": "Dimodifikasi",
    "wr-dashboard.content-table.message.empty-folder": "Folder ini kosong",
    "wr-dashboard.password-dialog-box.title.backup": "Cadangan terenkripsi",
    "wr-dashboard.password-dialog-box.title.archive": "Arsip terenkripsi",
    "wr-dashboard.password-dialog-box.message.backup": "Silakan tentukan kata sandi untuk mengakses cadangan {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Silakan tentukan kata sandi untuk mengakses arsip {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Kata sandi",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Kata sandi salah",
    "wr-dashboard.form.button.open": "Buka",
    "wr-dashboard.form.button.close": "Tutup",
    "wr-dashboard.form.button.cancel": "Batalkan",
    "wr-dashboard.form.button.continue": "Lanjutkan",
    "wr-dashboard.form.button.proceed": "Memproses",
    "wr-dashboard.form.button.delete": "Hapus",
    "wr-dashboard.form.button.done": "Selesai",
    "wr-dashboard.form.button.retry": "Coba lagi",
    "wr-dashboard.notary.verify.view.status.downloading": "Mengunduh...",
    "wr-dashboard.notary.verify.view.status.validating": "Memvalidasi...",
    "wr-dashboard.notary.verify.view.status.pending": "Sertifikat tertunda...",
    "wr-dashboard.notary.verify.view.status.fail": "Sertifikat tidak cocok...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Dapatkan sertifikat",
    "wr-dashboard.notary.verify.view.file-info.name": "NAMA",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "DITANDATANGANI OLEH",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "TANGGAL DICADANGKAN",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "TANGGAL DINOTARISKAN",
    "wr-dashboard.notary.verify.view.button.cancel": "Batalkan",
    "wr-dashboard.notary.verify.view.button.done": "Selesai",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versi browser tidak didukung",
    "wr-dashboard.versions-dialog-box.title": "Versi {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Dikirim untuk ditandatangani",
    "wr-dashboard.asign-dialog-box.message": "Versi file dibagikan tetapi tidak ada yang dapat menampilkan file tanpa tautan tersebut. Lanjutkan ke ASign untuk menambahkan penandatanganan dan membagikan tautan.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Tampilkan Detail file",
    "wr-dashboard.page-not-found.title": "Halaman tidak ditemukan",
    "wr-dashboard.page-not-found.message.main": "Halaman yang Anda cari tidak ditemukan.",
    "wr-dashboard.page-not-found.message.description": "Tautan tersebut mungkin sudah kedaluwarsa, atau bisa jadi Anda telah salah menuliskan alamat.",
    "wr-dashboard.page-not-found.message.error": "Kode kesalahan: 404",
    "wr-dashboard.server-error.title": "Server tidak tersedia",
    "wr-dashboard.server-error.message": "Server tidak tersedia saat ini. Coba lagi nanti.",
    "wr-dashboard.server-error.message.error": "Kode kesalahan: 500",
    "wr-dashboard.account-menu.action.sign-out": "Keluar",
    "wr-dashboard.breadcrumb.item.machines": "Mesin",
    "wr-dashboard.breadcrumb.item.failed-backups": "Cadangan yang gagal",
    "wr-dashboard.machines-table.column.name": "Nama",
    "wr-dashboard.machines-table.column.size": "Ukuran",
    "wr-dashboard.machines-table.message.no-machines": "Belum ada mesin dalam Awan",
    "wr-dashboard.incomplete-backups.message.status:plural": "Anda memiliki {count} cadangan yang gagal dalam {size} penyimpanan | Anda memiliki {count} cadangan yang gagal dalam {size} penyimpanan",
    "wr-dashboard.incomplete-backups.button.view": "Lihat cadangan",
    "wr-dashboard.incomplete-backups.button.delete": "Hapus cadangan",
    "wr-dashboard.machines-table.message.space-used:plural": "Total penggunaan cadangan {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Hapus arsip",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Hapus arsip tidak lengkap",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Hapus semua arsip tidak lengkap",
    "wr-dashboard.delete-archive.message": "Anda yakin ingin menghapus arsip yang dipilih secara permanen dari semua lokasi? Semua data akan dihapus dan tidak dapat dipulihkan.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Sertifikat menunggu",
    "wr-dashboard.certificate-pending-dialog-box.message": "Harap coba lagi dalam beberapa menit.",
    "wr-dashboard.form.button.ok": "Ok"
};
